import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractListStatus: 'idle',
    loadContractListError: undefined as any,
    loadContractListLastArgs: undefined as any,
    loadContractStatus: 'idle',
    loadContractError: undefined as any,
    saveContractStatus: 'idle',
    saveContractError: undefined as any,
    loadVertragsmanagementTabSollStatus: 'idle',
    loadVertragsmanagementTabSollError: undefined as any,
    loadVertragsmanagementTabIndexStatus: 'idle',
    loadVertragsmanagementTabIndexError: undefined as any,
    loadVertragsmanagementTabKuendigungStatus: 'idle',
    loadVertragsmanagementTabKuendigungError: undefined as any,
    loadVertragsmanagementTabOptionStatus: 'idle',
    loadVertragsmanagementTabOptionError: undefined as any,
    loadVertragsmanagementTabUmlageStatus: 'idle',
    loadVertragsmanagementTabUmlageError: undefined as any,
    loadVertragsmanagementTabEinzelsollbetraegeStatus: 'idle',
    loadVertragsmanagementTabEinzelsollbetraegeError: undefined as any,
    loadVertragsmanagementTabMietfreiezeitStatus: 'idle',
    loadVertragsmanagementTabMietfreiezeitError: undefined as any,
    loadVertragsmanagementTabUmsatzStatus: 'idle',
    loadVertragsmanagementTabUmsatzError: undefined as any,
    loadVertragsmanagementTabKonkurrenzschutzStatus: 'idle',
    loadVertragsmanagementTabKonkurrenzschutzError: undefined as any,
    loadVertragsmanagementTabInstandhaltungStatus: 'idle',
    loadVertragsmanagementTabInstandhaltungError: undefined as any,
    loadVertragsmanagementAbschlussDatSichtbarStatus: 'idle',
    loadVertragsmanagementAbschlussDatSichtbarError: undefined as any,
    loadVertragsmanagementMietVerlDatSichtbarStatus: 'idle',
    loadVertragsmanagementMietVerlDatSichtbarError: undefined as any,
    loadVertragsmanagementKeineSollstellungEditierbarStatus: 'idle',
    loadVertragsmanagementKeineSollstellungEditierbarError: undefined as any,

    flbelList: [] as any[],
    formItem: undefined as any,
    vertragsmanagementAbschlussDatSichtbar: undefined as any,
    vertragsmanagementKeineSollstellungEditierbar: undefined as any,
    vertragsmanagementMietVerlDatSichtbar: undefined as any,
    vertragsmanagementTabEinzelsollbetraege: undefined as any,
    vertragsmanagementTabIndex: undefined as any,
    vertragsmanagementTabInstandhaltung: undefined as any,
    vertragsmanagementTabKonkurrenzschutz: undefined as any,
    vertragsmanagementTabKuendigung: undefined as any,
    vertragsmanagementTabMietfreiezeit: undefined as any,
    vertragsmanagementTabOption: undefined as any,
    vertragsmanagementTabSoll: undefined as any,
    vertragsmanagementTabUmlage: undefined as any,
    vertragsmanagementTabUmsatz: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractList = createAsyncThunk('flbelSlice/loadContractList', async ({ globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flbelSlice.loadContractListLastArgs
    if (_.isEqual(lastArgs, { globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/flbel/?action=gte&MIN_OBJNR=${globalFilters.objectFilter || '0'}&MAX_OBJNR=${globalFilters.objectFilter || '99999'}`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractListStatus } = getState().flbelSlice
        return loadContractListStatus !== 'pending'
    }
})

export const loadContract = createAsyncThunk('flbelSlice/loadContract', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flbel/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractStatus } = getState().flbelSlice
        return loadContractStatus !== 'pending'
    }
})

export const saveContract = createAsyncThunk('flbelSlice/saveContract', async ({ flbel }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flbel?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flbel/${ flbel?.HDR_ID }/`,
            prepareData(flbel),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flbel/`,
            prepareData(flbel),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveContractStatus } = getState().flbelSlice
        return saveContractStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabSoll = createAsyncThunk('flbelSlice/loadVertragsmanagementTabSoll', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabSoll/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabSollStatus } = getState().flbelSlice
        return loadVertragsmanagementTabSollStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabIndex = createAsyncThunk('flbelSlice/loadVertragsmanagementTabIndex', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabIndex/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabIndexStatus } = getState().flbelSlice
        return loadVertragsmanagementTabIndexStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabKuendigung = createAsyncThunk('flbelSlice/loadVertragsmanagementTabKuendigung', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabKuendigung/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabKuendigungStatus } = getState().flbelSlice
        return loadVertragsmanagementTabKuendigungStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabOption = createAsyncThunk('flbelSlice/loadVertragsmanagementTabOption', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabOption/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabOptionStatus } = getState().flbelSlice
        return loadVertragsmanagementTabOptionStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabUmlage = createAsyncThunk('flbelSlice/loadVertragsmanagementTabUmlage', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabUmlage/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabUmlageStatus } = getState().flbelSlice
        return loadVertragsmanagementTabUmlageStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabEinzelsollbetraege = createAsyncThunk('flbelSlice/loadVertragsmanagementTabEinzelsollbetraege', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabEinzelsollbetraege/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabEinzelsollbetraegeStatus } = getState().flbelSlice
        return loadVertragsmanagementTabEinzelsollbetraegeStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabMietfreiezeit = createAsyncThunk('flbelSlice/loadVertragsmanagementTabMietfreiezeit', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabMietfreiezeit/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabMietfreiezeitStatus } = getState().flbelSlice
        return loadVertragsmanagementTabMietfreiezeitStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabUmsatz = createAsyncThunk('flbelSlice/loadVertragsmanagementTabUmsatz', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabUmsatz/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabUmsatzStatus } = getState().flbelSlice
        return loadVertragsmanagementTabUmsatzStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabKonkurrenzschutz = createAsyncThunk('flbelSlice/loadVertragsmanagementTabKonkurrenzschutz', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabKonkurrenzschutz/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabKonkurrenzschutzStatus } = getState().flbelSlice
        return loadVertragsmanagementTabKonkurrenzschutzStatus !== 'pending'
    }
})

export const loadVertragsmanagementTabInstandhaltung = createAsyncThunk('flbelSlice/loadVertragsmanagementTabInstandhaltung', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementTabInstandhaltung/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementTabInstandhaltungStatus } = getState().flbelSlice
        return loadVertragsmanagementTabInstandhaltungStatus !== 'pending'
    }
})

export const loadVertragsmanagementAbschlussDatSichtbar = createAsyncThunk('flbelSlice/loadVertragsmanagementAbschlussDatSichtbar', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementAbschlussDatSichtbar/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementAbschlussDatSichtbarStatus } = getState().flbelSlice
        return loadVertragsmanagementAbschlussDatSichtbarStatus !== 'pending'
    }
})

export const loadVertragsmanagementMietVerlDatSichtbar = createAsyncThunk('flbelSlice/loadVertragsmanagementMietVerlDatSichtbar', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementMietVerlDatSichtbar/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementMietVerlDatSichtbarStatus } = getState().flbelSlice
        return loadVertragsmanagementMietVerlDatSichtbarStatus !== 'pending'
    }
})

export const loadVertragsmanagementKeineSollstellungEditierbar = createAsyncThunk('flbelSlice/loadVertragsmanagementKeineSollstellungEditierbar', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragsmanagementKeineSollstellungEditierbar/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVertragsmanagementKeineSollstellungEditierbarStatus } = getState().flbelSlice
        return loadVertragsmanagementKeineSollstellungEditierbarStatus !== 'pending'
    }
})

const FlbelSlice = createSlice({
    name: 'flbelSlice',
    initialState,
    reducers: {
        resetloadContractListError: (state) => {
            state.loadContractListError = undefined
        },
        resetloadContract: (state) => {
            state.formItem = undefined
            state.loadContractError = undefined
        },
        resetloadContractError: (state) => {
            state.loadContractError = undefined
        },
        resetsaveContract: (state) => {
            state.formItem = undefined
            state.saveContractError = undefined
        },
        resetsaveContractError: (state) => {
            state.saveContractError = undefined
        },
        resetloadVertragsmanagementTabSoll: (state) => {
            state.vertragsmanagementTabSoll = undefined
            state.loadVertragsmanagementTabSollError = undefined
        },
        resetloadVertragsmanagementTabSollError: (state) => {
            state.loadVertragsmanagementTabSollError = undefined
        },
        resetloadVertragsmanagementTabIndex: (state) => {
            state.vertragsmanagementTabIndex = undefined
            state.loadVertragsmanagementTabIndexError = undefined
        },
        resetloadVertragsmanagementTabIndexError: (state) => {
            state.loadVertragsmanagementTabIndexError = undefined
        },
        resetloadVertragsmanagementTabKuendigung: (state) => {
            state.vertragsmanagementTabKuendigung = undefined
            state.loadVertragsmanagementTabKuendigungError = undefined
        },
        resetloadVertragsmanagementTabKuendigungError: (state) => {
            state.loadVertragsmanagementTabKuendigungError = undefined
        },
        resetloadVertragsmanagementTabOption: (state) => {
            state.vertragsmanagementTabOption = undefined
            state.loadVertragsmanagementTabOptionError = undefined
        },
        resetloadVertragsmanagementTabOptionError: (state) => {
            state.loadVertragsmanagementTabOptionError = undefined
        },
        resetloadVertragsmanagementTabUmlage: (state) => {
            state.vertragsmanagementTabUmlage = undefined
            state.loadVertragsmanagementTabUmlageError = undefined
        },
        resetloadVertragsmanagementTabUmlageError: (state) => {
            state.loadVertragsmanagementTabUmlageError = undefined
        },
        resetloadVertragsmanagementTabEinzelsollbetraege: (state) => {
            state.vertragsmanagementTabEinzelsollbetraege = undefined
            state.loadVertragsmanagementTabEinzelsollbetraegeError = undefined
        },
        resetloadVertragsmanagementTabEinzelsollbetraegeError: (state) => {
            state.loadVertragsmanagementTabEinzelsollbetraegeError = undefined
        },
        resetloadVertragsmanagementTabMietfreiezeit: (state) => {
            state.vertragsmanagementTabMietfreiezeit = undefined
            state.loadVertragsmanagementTabMietfreiezeitError = undefined
        },
        resetloadVertragsmanagementTabMietfreiezeitError: (state) => {
            state.loadVertragsmanagementTabMietfreiezeitError = undefined
        },
        resetloadVertragsmanagementTabUmsatz: (state) => {
            state.vertragsmanagementTabUmsatz = undefined
            state.loadVertragsmanagementTabUmsatzError = undefined
        },
        resetloadVertragsmanagementTabUmsatzError: (state) => {
            state.loadVertragsmanagementTabUmsatzError = undefined
        },
        resetloadVertragsmanagementTabKonkurrenzschutz: (state) => {
            state.vertragsmanagementTabKonkurrenzschutz = undefined
            state.loadVertragsmanagementTabKonkurrenzschutzError = undefined
        },
        resetloadVertragsmanagementTabKonkurrenzschutzError: (state) => {
            state.loadVertragsmanagementTabKonkurrenzschutzError = undefined
        },
        resetloadVertragsmanagementTabInstandhaltung: (state) => {
            state.vertragsmanagementTabInstandhaltung = undefined
            state.loadVertragsmanagementTabInstandhaltungError = undefined
        },
        resetloadVertragsmanagementTabInstandhaltungError: (state) => {
            state.loadVertragsmanagementTabInstandhaltungError = undefined
        },
        resetloadVertragsmanagementAbschlussDatSichtbar: (state) => {
            state.vertragsmanagementAbschlussDatSichtbar = undefined
            state.loadVertragsmanagementAbschlussDatSichtbarError = undefined
        },
        resetloadVertragsmanagementAbschlussDatSichtbarError: (state) => {
            state.loadVertragsmanagementAbschlussDatSichtbarError = undefined
        },
        resetloadVertragsmanagementMietVerlDatSichtbar: (state) => {
            state.vertragsmanagementMietVerlDatSichtbar = undefined
            state.loadVertragsmanagementMietVerlDatSichtbarError = undefined
        },
        resetloadVertragsmanagementMietVerlDatSichtbarError: (state) => {
            state.loadVertragsmanagementMietVerlDatSichtbarError = undefined
        },
        resetloadVertragsmanagementKeineSollstellungEditierbar: (state) => {
            state.vertragsmanagementKeineSollstellungEditierbar = undefined
            state.loadVertragsmanagementKeineSollstellungEditierbarError = undefined
        },
        resetloadVertragsmanagementKeineSollstellungEditierbarError: (state) => {
            state.loadVertragsmanagementKeineSollstellungEditierbarError = undefined
        },
        removeFromFlbelListById: (state, action) => {
            state.flbelList = state.flbelList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlbelListByIds: (state, action) => {
            state.flbelList = state.flbelList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flbelList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractListStatus = 'preloaded'
            state.loadContractListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flbelList = []
            state.loadContractListStatus = 'idle'
            state.loadContractListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractList.pending, (state) => {
            state.loadContractListStatus = 'pending'
            state.loadContractListError = undefined
        })
        builder.addCase(loadContractList.fulfilled, (state, action) => {
            state.loadContractListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractListLastArgs = action.payload.args

            {
                state.flbelList = action.payload.data

            }
        })
        builder.addCase(loadContractList.rejected, (state, action) => {
            state.loadContractListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractListError = action.error.message
            } else {
                state.loadContractListError = action.payload
            }
        })

        builder.addCase(loadContract.pending, (state) => {
            state.loadContractStatus = 'pending'
            state.loadContractError = undefined
        })
        builder.addCase(loadContract.fulfilled, (state, action) => {
            state.loadContractStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flbelList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flbelList.push(newItem) }
                else { state.flbelList[i] = { ...state.flbelList[i], ...newItem } }
            }
        })
        builder.addCase(loadContract.rejected, (state, action) => {
            state.loadContractStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractError = action.error.message
            } else {
                state.loadContractError = action.payload
            }
        })

        builder.addCase(saveContract.pending, (state) => {
            state.saveContractStatus = 'pending'
            state.saveContractError = undefined
        })
        builder.addCase(saveContract.fulfilled, (state, action) => {
            state.saveContractStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flbelList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flbelList.push(newItem) }
                else { state.flbelList[i] = { ...state.flbelList[i], ...newItem } }
            }
        })
        builder.addCase(saveContract.rejected, (state, action) => {
            state.saveContractStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveContractError = action.error.message
            } else {
                state.saveContractError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabSoll.pending, (state) => {
            state.loadVertragsmanagementTabSollStatus = 'pending'
            state.loadVertragsmanagementTabSollError = undefined
        })
        builder.addCase(loadVertragsmanagementTabSoll.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabSollStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabSoll = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabSoll.rejected, (state, action) => {
            state.loadVertragsmanagementTabSollStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabSollError = action.error.message
            } else {
                state.loadVertragsmanagementTabSollError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabIndex.pending, (state) => {
            state.loadVertragsmanagementTabIndexStatus = 'pending'
            state.loadVertragsmanagementTabIndexError = undefined
        })
        builder.addCase(loadVertragsmanagementTabIndex.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabIndexStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabIndex = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabIndex.rejected, (state, action) => {
            state.loadVertragsmanagementTabIndexStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabIndexError = action.error.message
            } else {
                state.loadVertragsmanagementTabIndexError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabKuendigung.pending, (state) => {
            state.loadVertragsmanagementTabKuendigungStatus = 'pending'
            state.loadVertragsmanagementTabKuendigungError = undefined
        })
        builder.addCase(loadVertragsmanagementTabKuendigung.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabKuendigungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabKuendigung = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabKuendigung.rejected, (state, action) => {
            state.loadVertragsmanagementTabKuendigungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabKuendigungError = action.error.message
            } else {
                state.loadVertragsmanagementTabKuendigungError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabOption.pending, (state) => {
            state.loadVertragsmanagementTabOptionStatus = 'pending'
            state.loadVertragsmanagementTabOptionError = undefined
        })
        builder.addCase(loadVertragsmanagementTabOption.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabOptionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabOption = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabOption.rejected, (state, action) => {
            state.loadVertragsmanagementTabOptionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabOptionError = action.error.message
            } else {
                state.loadVertragsmanagementTabOptionError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabUmlage.pending, (state) => {
            state.loadVertragsmanagementTabUmlageStatus = 'pending'
            state.loadVertragsmanagementTabUmlageError = undefined
        })
        builder.addCase(loadVertragsmanagementTabUmlage.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabUmlageStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabUmlage = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabUmlage.rejected, (state, action) => {
            state.loadVertragsmanagementTabUmlageStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabUmlageError = action.error.message
            } else {
                state.loadVertragsmanagementTabUmlageError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabEinzelsollbetraege.pending, (state) => {
            state.loadVertragsmanagementTabEinzelsollbetraegeStatus = 'pending'
            state.loadVertragsmanagementTabEinzelsollbetraegeError = undefined
        })
        builder.addCase(loadVertragsmanagementTabEinzelsollbetraege.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabEinzelsollbetraegeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabEinzelsollbetraege = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabEinzelsollbetraege.rejected, (state, action) => {
            state.loadVertragsmanagementTabEinzelsollbetraegeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabEinzelsollbetraegeError = action.error.message
            } else {
                state.loadVertragsmanagementTabEinzelsollbetraegeError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabMietfreiezeit.pending, (state) => {
            state.loadVertragsmanagementTabMietfreiezeitStatus = 'pending'
            state.loadVertragsmanagementTabMietfreiezeitError = undefined
        })
        builder.addCase(loadVertragsmanagementTabMietfreiezeit.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabMietfreiezeitStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabMietfreiezeit = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabMietfreiezeit.rejected, (state, action) => {
            state.loadVertragsmanagementTabMietfreiezeitStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabMietfreiezeitError = action.error.message
            } else {
                state.loadVertragsmanagementTabMietfreiezeitError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabUmsatz.pending, (state) => {
            state.loadVertragsmanagementTabUmsatzStatus = 'pending'
            state.loadVertragsmanagementTabUmsatzError = undefined
        })
        builder.addCase(loadVertragsmanagementTabUmsatz.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabUmsatzStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabUmsatz = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabUmsatz.rejected, (state, action) => {
            state.loadVertragsmanagementTabUmsatzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabUmsatzError = action.error.message
            } else {
                state.loadVertragsmanagementTabUmsatzError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabKonkurrenzschutz.pending, (state) => {
            state.loadVertragsmanagementTabKonkurrenzschutzStatus = 'pending'
            state.loadVertragsmanagementTabKonkurrenzschutzError = undefined
        })
        builder.addCase(loadVertragsmanagementTabKonkurrenzschutz.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabKonkurrenzschutzStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabKonkurrenzschutz = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabKonkurrenzschutz.rejected, (state, action) => {
            state.loadVertragsmanagementTabKonkurrenzschutzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabKonkurrenzschutzError = action.error.message
            } else {
                state.loadVertragsmanagementTabKonkurrenzschutzError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementTabInstandhaltung.pending, (state) => {
            state.loadVertragsmanagementTabInstandhaltungStatus = 'pending'
            state.loadVertragsmanagementTabInstandhaltungError = undefined
        })
        builder.addCase(loadVertragsmanagementTabInstandhaltung.fulfilled, (state, action) => {
            state.loadVertragsmanagementTabInstandhaltungStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementTabInstandhaltung = newItem
            }
        })
        builder.addCase(loadVertragsmanagementTabInstandhaltung.rejected, (state, action) => {
            state.loadVertragsmanagementTabInstandhaltungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementTabInstandhaltungError = action.error.message
            } else {
                state.loadVertragsmanagementTabInstandhaltungError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementAbschlussDatSichtbar.pending, (state) => {
            state.loadVertragsmanagementAbschlussDatSichtbarStatus = 'pending'
            state.loadVertragsmanagementAbschlussDatSichtbarError = undefined
        })
        builder.addCase(loadVertragsmanagementAbschlussDatSichtbar.fulfilled, (state, action) => {
            state.loadVertragsmanagementAbschlussDatSichtbarStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementAbschlussDatSichtbar = newItem
            }
        })
        builder.addCase(loadVertragsmanagementAbschlussDatSichtbar.rejected, (state, action) => {
            state.loadVertragsmanagementAbschlussDatSichtbarStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementAbschlussDatSichtbarError = action.error.message
            } else {
                state.loadVertragsmanagementAbschlussDatSichtbarError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementMietVerlDatSichtbar.pending, (state) => {
            state.loadVertragsmanagementMietVerlDatSichtbarStatus = 'pending'
            state.loadVertragsmanagementMietVerlDatSichtbarError = undefined
        })
        builder.addCase(loadVertragsmanagementMietVerlDatSichtbar.fulfilled, (state, action) => {
            state.loadVertragsmanagementMietVerlDatSichtbarStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementMietVerlDatSichtbar = newItem
            }
        })
        builder.addCase(loadVertragsmanagementMietVerlDatSichtbar.rejected, (state, action) => {
            state.loadVertragsmanagementMietVerlDatSichtbarStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementMietVerlDatSichtbarError = action.error.message
            } else {
                state.loadVertragsmanagementMietVerlDatSichtbarError = action.payload
            }
        })

        builder.addCase(loadVertragsmanagementKeineSollstellungEditierbar.pending, (state) => {
            state.loadVertragsmanagementKeineSollstellungEditierbarStatus = 'pending'
            state.loadVertragsmanagementKeineSollstellungEditierbarError = undefined
        })
        builder.addCase(loadVertragsmanagementKeineSollstellungEditierbar.fulfilled, (state, action) => {
            state.loadVertragsmanagementKeineSollstellungEditierbarStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.vertragsmanagementKeineSollstellungEditierbar = newItem
            }
        })
        builder.addCase(loadVertragsmanagementKeineSollstellungEditierbar.rejected, (state, action) => {
            state.loadVertragsmanagementKeineSollstellungEditierbarStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVertragsmanagementKeineSollstellungEditierbarError = action.error.message
            } else {
                state.loadVertragsmanagementKeineSollstellungEditierbarError = action.payload
            }
        })

    }
})

export const {
    resetloadContractListError,
    resetloadContract,
    resetloadContractError,
    resetsaveContract,
    resetsaveContractError,
    resetloadVertragsmanagementTabSoll,
    resetloadVertragsmanagementTabSollError,
    resetloadVertragsmanagementTabIndex,
    resetloadVertragsmanagementTabIndexError,
    resetloadVertragsmanagementTabKuendigung,
    resetloadVertragsmanagementTabKuendigungError,
    resetloadVertragsmanagementTabOption,
    resetloadVertragsmanagementTabOptionError,
    resetloadVertragsmanagementTabUmlage,
    resetloadVertragsmanagementTabUmlageError,
    resetloadVertragsmanagementTabEinzelsollbetraege,
    resetloadVertragsmanagementTabEinzelsollbetraegeError,
    resetloadVertragsmanagementTabMietfreiezeit,
    resetloadVertragsmanagementTabMietfreiezeitError,
    resetloadVertragsmanagementTabUmsatz,
    resetloadVertragsmanagementTabUmsatzError,
    resetloadVertragsmanagementTabKonkurrenzschutz,
    resetloadVertragsmanagementTabKonkurrenzschutzError,
    resetloadVertragsmanagementTabInstandhaltung,
    resetloadVertragsmanagementTabInstandhaltungError,
    resetloadVertragsmanagementAbschlussDatSichtbar,
    resetloadVertragsmanagementAbschlussDatSichtbarError,
    resetloadVertragsmanagementMietVerlDatSichtbar,
    resetloadVertragsmanagementMietVerlDatSichtbarError,
    resetloadVertragsmanagementKeineSollstellungEditierbar,
    resetloadVertragsmanagementKeineSollstellungEditierbarError,
    removeFromFlbelListById,
    removeFromFlbelListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlbelSlice.actions
export default FlbelSlice.reducer
